const checkDevAndLocal = () => {
    switch (process.env.REACT_APP_DOMAIN) {
        case "https://dev.positivehotelyoga.com":
            return "dev";
        case "http://localhost:3000":
        case "http://localhost:3001":
            return "local";
        case "http://10.0.2.2:3000":
            return "local";
        default:
            return undefined;
    }
}

export { checkDevAndLocal }